export const API_BASE = (import.meta.env.VITE_API_BASE as string) || '';

export function getVersionedApiBase(version: string, base = API_BASE || '/v1') {
  const cleanBase = (base || '/v1').replace(/\/$/, '');
  if (/\/v\d+$/i.test(cleanBase)) return cleanBase.replace(/\/v\d+$/i, `/${version}`);
  return `${cleanBase}/${version}`;
}
// Prefer runtime config, then build-time, then meta/localStorage
let API_KEY: string | undefined = undefined;
try {
  const cfg = (window as any).__afwConfig;
  if (cfg && typeof cfg.apiKey === 'string' && cfg.apiKey) API_KEY = cfg.apiKey;
} catch {}
if (!API_KEY) {
  API_KEY = import.meta.env.VITE_API_KEY as string | undefined;
}
// Fallbacks to support live runtime configuration without rebuilds
if (!API_KEY) {
  try {
    const meta = (document?.querySelector?.('meta[name="afw-api-key"]') ||
                  document?.querySelector?.('meta[name="afwApiKey"]') ||
                  document?.querySelector?.('meta[name="0"]')) as HTMLMetaElement | null;
    const mv = (meta && meta.content) || '';
    if (mv) API_KEY = mv;
  } catch {}
}
if (!API_KEY) {
  try { const k = localStorage.getItem('afw.api.key') || ''; if (k) API_KEY = k; } catch {}
}

export async function apiGet(path: string, init: RequestInit = {}) {
  const url = API_BASE.replace(/\/$/, '') + path;
  const headers: Record<string, string> = { ...(init.headers as any) };
  if (API_KEY) headers['X-API-Key'] = API_KEY;
  const res = await fetch(url, { ...init, headers });
  return res;
}

export async function apiFetch(path: string, init: RequestInit = {}) {
  // Generic variant that also ensures X-API-Key is attached
  const url = API_BASE.replace(/\/$/, '') + path;
  const headers: Record<string, string> = { ...(init.headers as any) };
  if (API_KEY) headers['X-API-Key'] = API_KEY;
  const res = await fetch(url, { ...init, headers });
  try {
    if (res.status === 401 || res.status === 403) {
      // If dev token is invalid/expired, clear it and redirect to login.
      const devToken = localStorage.getItem('afw.dev.token') || '';
      if (devToken && /\/dev\//.test(path)) {
        try { localStorage.removeItem('afw.dev.token'); } catch {}
        if (typeof window !== 'undefined') {
          window.location.href = '/login';
        }
      }
    }
  } catch {}
  return res;
}
